"use strict";
/**
 * API Response Types for Image Upload - Hash-Only System
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageUploadEntityType = void 0;
// Entity types for image uploads
var ImageUploadEntityType;
(function (ImageUploadEntityType) {
    ImageUploadEntityType["PATTERN_TEMP"] = "pattern-temp";
    ImageUploadEntityType["PATTERN_DRAFT"] = "pattern-draft";
    ImageUploadEntityType["PATTERN_COMPONENT"] = "pattern-component";
    ImageUploadEntityType["MATERIAL"] = "material";
    ImageUploadEntityType["MATERIAL_TEMP"] = "material-temp";
    ImageUploadEntityType["PROJECT"] = "project";
    ImageUploadEntityType["PROJECT_TEMP"] = "project-temp";
    ImageUploadEntityType["PROFILE"] = "profile";
    ImageUploadEntityType["REVIEW"] = "review-temp";
    ImageUploadEntityType["COMMENT"] = "comment-temp";
    ImageUploadEntityType["CRAFT_ROOM"] = "craft-room";
    ImageUploadEntityType["DRAFT_REVIEW"] = "draft-review-temp";
})(ImageUploadEntityType || (exports.ImageUploadEntityType = ImageUploadEntityType = {}));
